import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewbox="0 0 20 20" fill="none"><path fill="currentColor" d="M2.796 10.215c0-.73.136-1.428.408-2.091A5.433 5.433 0 0 1 4.4 6.34a5.295 5.295 0 0 1 1.59-1.11 6.487 6.487 0 0 1 1.869-.508c.177-.02.341-.048.494-.086.157-.043.305-.095.444-.157.143-.067.28-.146.408-.237.133-.095.265-.205.394-.33a4.379 4.379 0 0 1 1.174-.823 3.23 3.23 0 0 1 1.404-.293c.468 0 .917.088 1.346.265.435.177.817.43 1.146.759.253.257.504.51.752.759.253.248.507.501.76.759.329.334.581.714.758 1.139.177.425.265.873.265 1.346 0 .267-.026.516-.078.745-.048.229-.12.448-.215.659-.09.21-.208.413-.351.608a5.56 5.56 0 0 1-.473.566 2.845 2.845 0 0 0-.558.802 3.151 3.151 0 0 0-.251.938 6.565 6.565 0 0 1-.501 1.877 5.277 5.277 0 0 1-1.11 1.582c-.52.52-1.115.917-1.784 1.19a5.407 5.407 0 0 1-2.098.414 5.395 5.395 0 0 1-2.098-.415A5.363 5.363 0 0 1 5.911 15.6l-.81-.809-.809-.81a4.76 4.76 0 0 1-.637-.808 5.63 5.63 0 0 1-.473-.931 6.012 6.012 0 0 1-.286-1.003 5.371 5.371 0 0 1-.1-1.024Zm.802 0c0 .43.055.845.164 1.246.115.396.272.768.473 1.117.205.344.449.659.73.945.287.287.602.533.946.738.349.2.721.358 1.117.473a4.72 4.72 0 0 0 2.199.064 5.27 5.27 0 0 0 .802-.236c.281-.11.532-.241.752-.394a.7.7 0 0 0 .2-.215.55.55 0 0 0 .079-.293.62.62 0 0 0-.057-.251l-1.468-3.08c-.139-.3-.33-.567-.573-.802a2.768 2.768 0 0 0-.81-.565L5.06 7.515a.639.639 0 0 0-.258-.057.521.521 0 0 0-.287.078.645.645 0 0 0-.207.201c-.115.172-.217.36-.308.566-.087.2-.16.408-.222.623a6.036 6.036 0 0 0-.136.651 4.89 4.89 0 0 0-.044.638Zm8.157 2.764c.08 0 .162-.017.243-.05a.533.533 0 0 0 .2-.158c.11-.138.208-.298.294-.48a4.73 4.73 0 0 0 .222-.572c.067-.2.122-.401.165-.602.043-.2.071-.386.086-.558.081-.87.43-1.617 1.045-2.242.282-.287.5-.59.652-.91.153-.32.23-.683.23-1.088a2.703 2.703 0 0 0-.781-1.92 2.66 2.66 0 0 0-.86-.572 2.575 2.575 0 0 0-1.052-.215c-.407 0-.774.077-1.103.23-.33.147-.637.362-.924.644-.31.3-.654.539-1.031.716a3.517 3.517 0 0 1-1.21.322 5.595 5.595 0 0 0-1.125.236c-.373.115-.716.28-1.031.495a.566.566 0 0 0-.272.5c0 .115.029.22.086.316a.63.63 0 0 0 .25.222l2.535 1.196c.01 0 .015.002.015.007.09.038.184.069.279.093a1.27 1.27 0 0 0 .687-.021 1.45 1.45 0 0 0 .316-.165c.1-.071.195-.152.286-.243.09-.096.186-.194.286-.294a.909.909 0 0 0 .201-.3.855.855 0 0 0 .079-.359 1.13 1.13 0 0 0-.057-.358 1.359 1.359 0 0 1-.05-.365c0-.22.04-.428.121-.623.086-.196.2-.368.344-.516a1.51 1.51 0 0 1 .501-.344 1.55 1.55 0 0 1 .63-.129c.22 0 .428.043.623.13.196.08.366.193.509.336.148.143.263.313.344.508.086.196.129.404.129.623 0 .22-.043.428-.13.623-.08.196-.195.368-.343.516a1.648 1.648 0 0 1-.509.344c-.19.086-.396.129-.615.129-.13 0-.254-.02-.373-.058a1.13 1.13 0 0 0-.358-.057.848.848 0 0 0-.358.079 1.023 1.023 0 0 0-.308.2l-.286.287a1.655 1.655 0 0 0-.401.594 1.231 1.231 0 0 0-.058.394c0 .21.043.403.13.58v.007c.004 0 .006.003.006.008l1.203 2.52a.66.66 0 0 0 .215.251.583.583 0 0 0 .323.093Zm-.638-6.531a.9.9 0 0 0 .065.344.94.94 0 0 0 .473.472.888.888 0 0 0 .343.065.895.895 0 0 0 .344-.065.897.897 0 0 0 .286-.193.835.835 0 0 0 .186-.28.813.813 0 0 0 .072-.343.799.799 0 0 0-.072-.337.82.82 0 0 0-.472-.472.82.82 0 0 0-.344-.072.82.82 0 0 0-.344.072.84.84 0 0 0-.279.186.915.915 0 0 0-.193.286.878.878 0 0 0-.065.337Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
